module.exports = __webpack_public_path__ + "static/media/transparency@2x.01b3a020.png";